var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFastExitAndEntry = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "45px",
    viewBox: "0 0 42 45",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5.-Index-Builder---Create-New-Methodology---Cards---00",
    transform: "translate(-1067.000000, -377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-2",
    transform: "translate(598.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(15.100000, 13.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography",
    transform: "translate(152.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Maps-/-transfer_within_a_station",
    transform: "translate(0.900000, 0.750000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 50 0 50 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3541667,32.2916667 L34.3541667,28.6458333 L29.1666667,33.8541667 L34.3541667,39.0625 L34.3541667,35.4166667 L45.8333333,35.4166667 L45.8333333,32.2916667 L34.3541667,32.2916667 L34.3541667,32.2916667 Z M40.6458333,41.1458333 L29.1666667,41.1458333 L29.1666667,44.2708333 L40.6458333,44.2708333 L40.6458333,47.9166667 L45.8333333,42.7083333 L40.6458333,37.5 L40.6458333,41.1458333 L40.6458333,41.1458333 Z M19.7916667,11.4583333 C22.0833333,11.4583333 23.9583333,9.58333333 23.9583333,7.29166667 C23.9583333,5 22.0833333,3.125 19.7916667,3.125 C17.5,3.125 15.625,5 15.625,7.29166667 C15.625,9.58333333 17.5,11.4583333 19.7916667,11.4583333 Z M11.9791667,18.5416667 L6.25,47.9166667 L10.625,47.9166667 L14.2708333,31.25 L18.75,35.4166667 L18.75,47.9166667 L22.9166667,47.9166667 L22.9166667,32.1875 L18.6458333,27.9166667 L19.8958333,21.6666667 C22.6041667,25 26.6666667,27.0833333 31.25,27.0833333 L31.25,22.9166667 C27.3958333,22.9166667 24.0625,20.8333333 22.1875,17.8125 L20.2083333,14.4791667 C19.4791667,13.2291667 18.125,12.5 16.6666667,12.5 C16.1458333,12.5 15.625,12.6041667 15.1041667,12.8125 L4.16666667,17.2916667 L4.16666667,27.0833333 L8.33333333,27.0833333 L8.33333333,20.1041667 L11.9791667,18.5416667 L11.9791667,18.5416667 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFastExitAndEntry, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/fast_exit_and_entry.4afb06e3.svg";
export { ForwardRef as ReactComponent };